import React from 'react';
import PropTypes from 'prop-types';
import classes from './statusForm.module.scss';
import ReviewStatus from './ReviewStatus';
import PriorAuthStatus from './PriorAuthStatus';
import CopayAssistanceStatus from './CopayAssistanceStatus';
import ScheduleStatus from './ScheduleStatus';
import QAStatus from './QAStatus';
import CancelledStatus from './CancelledStatus';

const StatusForm = ({
  info, currentTab, changeStatus, openCancelModal, changeScriptInfo, setRefillModalData, patientId,
}) => {
  const statuses = [
    {
      status: 'Cancelled',
      content: <CancelledStatus
        changeStatus={changeStatus}
        defaultReason={info.cancelReason || ''}
      />,
    },
    {
      status: 'Review',
      content: <ReviewStatus
        info={info}
        changeStatus={changeStatus}
        openCancelModal={openCancelModal}
      />,
    },
    {
      status: 'Prior Auth',
      content: <PriorAuthStatus
        changeStatus={changeStatus}
      />,
    },
    {
      status: 'Process',
      content: <ReviewStatus
        info={info}
        changeStatus={changeStatus}
        openCancelModal={openCancelModal}
        statusProcess
      />,
    },
    {
      status: 'Copay Assistance',
      content: <CopayAssistanceStatus
        info={info}
        changeStatus={changeStatus}
      />,
    },
    {
      status: 'Schedule',
      content: <ScheduleStatus
        info={info}
        currentTab={currentTab}
        changeStatus={changeStatus}
        changeScriptInfo={changeScriptInfo}
        patientId={patientId}
      />,
    },
    {
      status: 'QA',
      content: <QAStatus
        changeStatus={changeStatus}
      />,
    },
    {
      status: 'Fill',
      content: <QAStatus
        changeStatus={changeStatus}
        statusFill
        setRefillModalData={setRefillModalData}
      />,
    },
    {
      status: 'Shipped',
      content: <QAStatus
        changeStatus={changeStatus}
        statusShipped
      />,
    },
    {
      status: 'Refill',
      content: <QAStatus
        changeStatus={changeStatus}
        statusRefill
      />,
    },
    {
      status: 'Received',
      content: <QAStatus
        changeStatus={changeStatus}
        statusReceived
      />,
    },
  ];

  return (
    <div className={classes.status_content}>
      {statuses.find(({ status }) => status === info.status)?.content}
    </div>
  );
};

StatusForm.propTypes = {
  info: PropTypes.object.isRequired,
  currentTab: PropTypes.string.isRequired,
  changeStatus: PropTypes.func.isRequired,
  openCancelModal: PropTypes.func.isRequired,
  changeScriptInfo: PropTypes.func.isRequired,
  setRefillModalData: PropTypes.func.isRequired,
  patientId: PropTypes.number.isRequired,
};

export default StatusForm;
